import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppRootState } from '../../app/store';
import { Project } from './Project/Project';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ProjectType } from '../../api/projects-api';
import { checkAutoLogin, getUserData } from '../Login/auth-reducer';
import { fetchProjectsTC } from './project-reducer';
import { setCurrentLocation } from '../../app/cookies';

export const Projects = React.memo(() => {
  const dispatch = useDispatch()
  const projects = useSelector<AppRootState, Array<ProjectType>>((state) => state.projects)
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const navigate = useNavigate()
 
  useEffect(() => {
    setCurrentLocation('\\ Projects')
    let token = checkAutoLogin(dispatch, true)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } else {
      dispatch(fetchProjectsTC(token))
      dispatch(getUserData())
    }
  }, [isLoggedIn])
  
  return <>
    <Grid style={{ padding: '20px', paddingTop: '70px' }} container>
    </Grid>
    <Grid container spacing={3} >
      {projects.map(pr => {
        return <Grid item>
            <Project
              key={pr.id}
               project={pr}
              />
        </Grid>
      })}
    </Grid>
  </>
})
